import { render, staticRenderFns } from "./validation-hire-list.vue?vue&type=template&id=5b3f770b"
import script from "./validation-hire-list.vue?vue&type=script&lang=js"
export * from "./validation-hire-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports